class StickyBuyButton {
  constructor() {
    this.productForm = null;
    this.formContainer = null;
    this.formHeight = 0;
    this.init();
  }

  init() {
    // Only run on product pages
    if (!document.querySelector('.product-single')) {
      return;
    }

    // Find the original form
    this.productForm = document.querySelector('.product-form.product-form--single.js-product-form');
    if (!this.productForm) {
      return;
    }

    // Find the form container (the element that will maintain height)
    this.formContainer = this.productForm.parentElement;
    if (!this.formContainer) {
      return;
    }

    // maintain the sticky element parent's height so there is no jump when scrolling and form gets sticky
    let formStyle = window.getComputedStyle(this.productForm);
    let formMargin = parseFloat(formStyle.marginTop) + parseFloat(formStyle.marginBottom);
    this.formHeight = this.productForm.offsetHeight + formMargin;

    this.setupScrollListener();
    this.setupResizeListener();
  }

  setupScrollListener() {
    let ticking = false;
    
    const checkScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.updateStickyForm();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', checkScroll, { passive: true });
  }

  setupResizeListener() {
    let resizeTimer;
    
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.formHeight = this.productForm.offsetHeight;
        this.updateStickyForm();
      }, 100);
    };

    window.addEventListener('resize', handleResize);
  }

  updateStickyForm() {
    if (!this.productForm || !this.formContainer) {
      return;
    }

    // Only show on mobile
    if (window.innerWidth >= 980) {
      this.productForm.classList.remove('sticky-buy-form');
      this.formContainer.classList.remove('has-sticky-form');
      this.formContainer.style.removeProperty('--sticky-form-height');
      return;
    }

    const containerRect = this.formContainer.getBoundingClientRect();
    
    // Check if the container's bottom edge is above the viewport (scrolled past it)
    const isContainerOutOfView = containerRect.bottom < 0;
    
    if (isContainerOutOfView) {
      this.productForm.classList.add('sticky-buy-form');
      this.formContainer.classList.add('has-sticky-form');
      this.formContainer.style.setProperty('--sticky-form-height', `${this.formHeight}px`);
    } else {
      this.productForm.classList.remove('sticky-buy-form');
      this.formContainer.classList.remove('has-sticky-form');
      this.formContainer.style.removeProperty('--sticky-form-height');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new StickyBuyButton();
});

window.addEventListener('load', () => {
  new StickyBuyButton();
}); 